import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchRoles } from '@/api/access/accessApi';
import type { Role } from '@/api/access/accessApi.types';
import type { PaginatedResult } from '@/api/pagination.types';
import { ADMIN_LIST_PAGE_SIZE } from '@/constants/adminPagination';
import { ROLES_QUERY_KEY } from '@/constants/queryKeys';

export function useRolesQuery(
  page: number,
  search: string,
  scopeCode?: string
): UseQueryResult<PaginatedResult<Role>, Error> {
  return useQuery({
    queryKey: [...ROLES_QUERY_KEY, page, search, scopeCode],
    queryFn: function loadRoles() {
      return fetchRoles(page, ADMIN_LIST_PAGE_SIZE, search, scopeCode);
    },
    placeholderData: keepPreviousData,
  });
}
